import { Star, Quote } from "lucide-react";

const reviews = [
  {
    name: "Sophie M.",
    role: "Cabinet comptable, Aix-en-Provence",
    text: "80 cartons en sous-sol depuis 5 ans. Tout évacué en une demi-journée. Certificat le lendemain. Impeccable.",
  },
  {
    name: "Maître R. Dubois",
    role: "Notaire, Marseille",
    text: "Confidentialité, professionnalisme, réactivité. La traçabilité est parfaite. Je recommande sans hésiter.",
  },
  {
    name: "Karim B.",
    role: "DRH PME industrielle, Vitrolles",
    text: "Ils ont descendu nos cartons depuis le 3ème étage sans ascenseur. Service bluffant et discret.",
  },
  {
    name: "Élodie F.",
    role: "Office manager, Aubagne",
    text: "Plus de 200 cartons évacués en 2 jours. Aucune charge pour mon équipe. Tout simplement parfait.",
  },
  {
    name: "Cabinet Provence Avocats",
    role: "Avocats, Marseille",
    text: "Devis dans la journée, intervention 48h plus tard. Service rapide, discret et conforme. À recommander.",
  },
  {
    name: "Julien R.",
    role: "Gérant, agence immobilière Marignane",
    text: "Archives papier de 10 ans envolées sans le moindre effort. Équipe sérieuse et ponctuelle.",
  },
  {
    name: "Maître L. Vasseur",
    role: "Notaire associé, Aix-en-Provence",
    text: "Une intervention exemplaire. Tout a été pris en charge de A à Z. Je n'aurai plus à m'occuper de mes vieilles archives.",
  },
  {
    name: "Cabinet Salon Compta",
    role: "Expertise comptable, Salon-de-Provence",
    text: "Locaux libérés en une matinée. Discrétion totale et certificat reçu rapidement. Service très pro.",
  },
  {
    name: "Florent T.",
    role: "Dirigeant PME, Martigues",
    text: "Je n'ai rien eu à faire à part décrocher le téléphone. Devis clair, intervention rapide, équipe impeccable.",
  },
];

function Card({ r }) {
  return (
    <div
      className="shrink-0 w-[300px] sm:w-[360px] md:w-[400px] bg-white rounded-2xl p-6 md:p-7 border border-slate-200 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all"
      data-testid={`testimonial-${r.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      <div className="flex items-center justify-between">
        <Quote className="h-6 w-6 text-blue-600/40" strokeWidth={1.5} />
        <div className="flex text-amber-400">
          {[1,2,3,4,5].map((i) => (
            <Star key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" strokeWidth={0} />
          ))}
        </div>
      </div>
      <p className="mt-5 text-slate-800 leading-relaxed text-base font-medium">"{r.text}"</p>
      <div className="mt-7 pt-5 border-t border-slate-100 flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-slate-950 text-white font-bold flex items-center justify-center text-sm">
          {r.name.charAt(0)}
        </div>
        <div>
          <div className="font-bold text-slate-950 text-sm">{r.name}</div>
          <div className="text-xs text-slate-500">{r.role}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  // Duplicate twice for seamless loop
  const loop = [...reviews, ...reviews];

  return (
    <section
      className="py-24 md:py-36 bg-slate-50 overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
            Avis clients
          </div>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-950" data-testid="testimonials-title">
            120+ professionnels nous font confiance.
          </h2>
          <div className="mt-6 flex items-center justify-center gap-3">
            <div className="flex">
              {[1,2,3,4,5].map((i) => (
                <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" strokeWidth={0} />
              ))}
            </div>
            <div className="text-left">
              <div className="text-xl font-display font-bold text-slate-950 leading-none">4.9/5</div>
              <div className="text-xs text-slate-500">120+ retours clients PACA</div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee carousel */}
      <div className="relative group" data-testid="testimonials-marquee">
        {/* Edge fade masks */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-12 sm:w-20 md:w-32 bg-gradient-to-r from-slate-50 to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-12 sm:w-20 md:w-32 bg-gradient-to-l from-slate-50 to-transparent z-10" />

        <div className="flex gap-5 md:gap-6 animate-marquee will-change-transform py-2" style={{ width: "max-content" }}>
          {loop.map((r, i) => (
            <Card key={i} r={r} />
          ))}
        </div>
      </div>
    </section>
  );
}
